import { useEffect, useState } from "react";
import { Layout } from "@/components/Layout";
import { NewsCard } from "@/components/NewsCard";
import { Newspaper, ArrowRight, Loader2 } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function NewsListPage() {
  const [news, setNews] = useState(null);

  useEffect(() => {
    fetch(`${API}/api/news`)
      .then((r) => r.json())
      .then(setNews)
      .catch(() => setNews([]));
  }, []);

  return (
    <Layout>
      <section className="bg-[#1f2d22] text-white py-16 sm:py-20" data-testid="news-page-header">
        <div className="max-w-6xl mx-auto px-6 sm:px-8 lg:px-12">
          <div className="inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/20 px-4 py-1.5 mb-5">
            <Newspaper className="w-3.5 h-3.5 text-[#E8C9A0]" />
            <span className="text-[10px] sm:text-xs font-bold uppercase tracking-[0.22em] text-[#E8C9A0]">
              Notizie e aggiornamenti
            </span>
          </div>
          <h1 data-testid="news-page-title" className="font-display text-4xl sm:text-5xl lg:text-6xl font-black leading-[1.05] tracking-tight">
            Le ultime <span className="italic font-light text-[#E8C9A0]">novità.</span>
          </h1>
          <p className="mt-5 text-base sm:text-lg text-white/75 max-w-2xl leading-relaxed">
            Notizie, aggiornamenti, iniziative e racconti dell'associazione Per Asciano.
          </p>
        </div>
      </section>

      <section className="py-16 sm:py-20 bg-[#FBF9F6]">
        <div className="max-w-6xl mx-auto px-6 sm:px-8 lg:px-12">
          {news === null ? (
            <div className="flex items-center justify-center py-16 text-[#5C5C5C]">
              <Loader2 className="w-5 h-5 animate-spin mr-2" />
              Caricamento…
            </div>
          ) : news.length === 0 ? (
            <div className="text-center py-12 text-[#5C5C5C] italic">Nessuna notizia disponibile al momento.</div>
          ) : (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">
              {news.map((n) => (
                <NewsCard key={n.id} news={n} testidPrefix="news-card" />
              ))}
            </div>
          )}
        </div>
      </section>
    </Layout>
  );
}
